import { Box, Chip, TextField } from "@mui/material";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import { useQuery } from "react-query";
import { EXCHANGES } from "src/Api/endpoints";
import { getExchanges } from "src/Api";
import { Exchange } from "src/Common/types";
import { ExchangeIcon } from "../ExchangeIcon";

type Props = Omit<
  AutocompleteProps<Exchange, undefined | boolean, false, false>,
  "renderInput" | "options"
> & { inputLabel?: string };

export function AutocompleteExchange(props: Props) {
  const { data: exchanges, isLoading } = useQuery(EXCHANGES, getExchanges);

  return (
    <Autocomplete<Exchange, undefined | boolean, false, false>
      loading={isLoading}
      popupIcon={null}
      id="crypto-search"
      size="small"
      autoHighlight
      getOptionLabel={(option) => option.name}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            avatar={
              <ExchangeIcon
                style={{ height: "1rem", width: "1rem" }}
                name={option.name}
              />
            }
            size="small"
            label={option.name}
            {...getTagProps({ index })}
          />
        ))
      }
      renderOption={(props, option) => (
        <Box
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          component="li"
          {...props}
        >
          <ExchangeIcon style={{ height: "1.5rem" }} name={option.id} />
          <span>{option.name}</span>
        </Box>
      )}
      options={exchanges ?? []}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.inputLabel ?? null}
          InputProps={{
            ...params.InputProps,
            type: "search",
          }}
        />
      )}
      {...props}
    />
  );
}
